import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import frChevronRightSvg from '@src/svgs/fr-chevron-right.svg';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { FUNNEL_ROUTE } from '@src/Routes/links';
import { trackEvent } from '@src/metrics';
import { Link } from '@src/components/Link';
import { ChatHeaderProps } from './props';
import './styles.scss';

export const ChatHeader: FC<ChatHeaderProps> = ({ opening, doesUserVerificationProfileExist }) => {
  return (
    <Link
      className={classnames('inbox-chat-header', doesUserVerificationProfileExist && 'inbox-chat-header--small')}
      onClick={() =>
        trackEvent({
          context: MetricContext.CANDIDATE_MANAGEMENT,
          interaction: MetricAction.OPEN_TALENT_AGENT,
          payload: {
            'Event Source': MetricEventSource.CHATS_HEADER,
            'Opening Id': opening.id,
            'Previous Context': MetricContext.CHATS,
          },
        })
      }
      params={{ openingId: opening.id }}
      to={FUNNEL_ROUTE}
    >
      <div className="inbox-chat-header__description">
        <div className="inbox-chat-header__description-label">{opening.title}</div>

        <Svg src={frChevronRightSvg} />
      </div>
    </Link>
  );
};
